// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"f3ea508d","55":"af941c33","139":"979b331f","173":"3482d635","245":"afeda5fc","391":"02437fcf","453":"98233b38","469":"0e40c727","672":"cd95df91","865":"b154d11e","914":"0960019c","950":"e169daa9"}[chunkId] + ".chunk.js";
};